<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container-fluid">
        <div class="page-title-content" >
            <h2 data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">WhatsApp Sender</h2>
            <ul data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200"  >
                <li><a routerLink="/">Home</a></li>
                <li>WhatsApp Sender</li>
            </ul>
        </div>
    </div>
    
</div>
<section class="team-area ">
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">

                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Effortless-Sending.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-sm-2 ">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                           Effortless Sending
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Send bulk WhatsApp messages directly through your website using a user-friendly API.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                             Contact Management
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 15px ;
                            ">
                           Import and manage large contact lists efficiently. This should include features like:  </p>
                           <ul style="    line-height: 38px ; color: #4c118e;">
                            <li >Deduplication: Remove duplicate contacts to ensure efficient messaging.</li>
                           <li>Segmentation & Groups: Segment your audience and create targeted groups for personalized campaigns.</li>
                           <li>Opt-in Management: Clearly obtain and manage user consent to comply with WhatsApp regulations.</li>
                        </ul>	
                           	
                           	
                           
                        
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Contact-Management.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Message-Personalization.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                             Message Personalization
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Personalize messages with user data like name, purchase history, or previous interactions for a more engaging experience.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Media Support
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                             Include rich media like images, videos, and documents within messages to enhance content.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Media-Support.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Delivery-Reports.png" alt="image"  style="max-width: 55% !important; "/>
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Delivery Reports & Tracking
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Track message delivery status (sent, delivered, read) for campaign monitoring.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Message Scheduling
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Schedule messages to be sent at optimal times for maximum impact, considering time zones.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Message-Scheduling.png" alt="image" style="max-width: 55%;" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/WhatsApp-Business-Profile.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                              WhatsApp Business Profile Integration
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Connect your WhatsApp Business profile for a seamless user experience.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                              Campaign Analytics
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Track key metrics like open rates, click-through rates, and engagement rates to measure campaign effectiveness.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Campaign-Analytics.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/compliance.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                             Compliance
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Ensure adherence to WhatsApp Business API guidelines and user consent regulations.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                             Security
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                             Implement strong security measures to protect user data and maintain message privacy.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/robotic-security.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Broadcast-Lists.png" alt="image"  style="max-width: 70% !important; "/>
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                             Broadcast Lists & Templates
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Create reusable broadcast lists and message templates for faster campaign creation.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Scalability
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           The API should handle large message volumes without compromising performance.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Scalability-1.png" alt="image" style="max-width: 55%;" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Error-Handling.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                             Error Handling & Reporting
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Provide clear error reports for troubleshooting and improving message delivery success rates.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                              Integration Options
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Integrate with CRM, marketing automation, or e-commerce platforms for a streamlined workflow.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Integration-Options.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Auto-Replies.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                              Auto-replies
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Set up automated responses to frequently asked questions or basic inquiries.
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="warpper container-fluid" style="padding-left: 180px ; padding-right: 180px;">
        <input class="radio" id="one" name="group" type="radio" checked>
        <input class="radio" id="two" name="group" type="radio">
        <input class="radio" id="three" name="group" type="radio">
        <div class="tabs">
            <label >Benefits of Whatsapp</label>
            <!-- <label class="tab" id="two-tab" for="two">Promotional Messages</label>
            <label class="tab" id="three-tab" for="three">Informational Messages</label> -->
        </div>
        <div class="panels">
            <div class="panel" id="one-panel">
                <div class="row mt-5 mt-md-3 row-cols-1 row-cols-sm-1 row-cols-md-3 justify-content-center">
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-key"></i>
                            </div>
                            <h3> Increased Reach</h3>
                            <p>
                                Reach a wider audience directly on their preferred messaging platform.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-arrows-down-to-people"></i>
                            </div>
                            <h3> Improved Engagement</h3>
                            <p>
                                High open rates and direct communication foster better customer interaction.                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-shopping-cart"></i>
                            </div>
                            <h3>  Personalization at Scale</h3>
                            <p>
                                Send targeted messages with user data for a more relevant experience.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-money"></i>
                            </div>
                            <h3>  Cost-Effectiveness</h3>
                            <p>
                                Reach a large audience at a lower cost compared to traditional marketing channels.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-database"></i>
                            </div>
                            <h3>  Data-Driven Optimization</h3>
                            <p>
                                Track results and optimize campaigns for continuous improvement.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
           
        </div>
    </div>


    <div class="container-fluid">
      

        <div class="pricing">
            <h3 style="text-align: center; font-size: 24px; ">Pricing</h3>
            <div class="container">
            <table>
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Product Name</th>
                        <th>Quantity Slab</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>SMS</td>
                        <td>10,000 @15 Paise</td>
                        <td>Rs. 1,500/-</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>SMS</td>
                        <td>50,000 @13 Paise</td>
                        <td>Rs. 6,500/-</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>SMS</td>
                        <td>1 Lakh @10 Paise</td>
                        <td>Rs. 10,000/-</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>SMS</td>
                        <td>5 Lakh @8 Paise</td>
                        <td>Rs. 40,000/-</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>SMS</td>
                        <td>10 Lakh @7 Paise</td>
                        <td>Rs. 70,000/-</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>SMS</td>
                        <td>1 Crore @5 Paise</td>
                        <td>Rs. 5,00,000/-</td>
                    </tr>
                </tbody>
            </table>
        </div>
            <h3>Pricing: (GST Exclusive, as applicable)</h3>
        </div>
        
    </div>


</section>
<div class="full-row" #seprator id="seprator">
    <div class="container-fluid">
        <h6>
            Want to Improve the Experience of Your Customers? Our Dedicated Team Is Here to Help You Out!


        </h6>
        <a class="btns btn-primarys" routerLink="/contact">
            CONTACT US
        </a>
    </div>
</div>
